// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__a-FCL","actions":"GroupTable_actions__hs49Z","deleteModalFooter":"GroupTable_deleteModalFooter__1sLnd"};